
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear  placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" >
      <a-button type="primary" icon="plus" @click="addHandle" >新建</a-button>
    </div>

    <s-table
            ref="table"
            size="default"
            :columns="columns"
            :data="loadData"
            :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="name" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{record.name}}
          </div>
      </span>
      <span slot="status" slot-scope="text,record">


        <a-tag v-if="record.status==1" color="green">显示</a-tag>
        <a-tag v-else>不显示</a-tag>


      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
              <a-popconfirm
                      title="确定删除吗"
                      @confirm="onDelete(record)"
                      okText="确定"
                      cancelText="取消"
              >
                <a href="javascript:;">删除</a>
              </a-popconfirm>
        </template>
      </span>
    </s-table>



    <a-modal
        :maskClosable="false"
            title="操作"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="名称"
                      hasFeedback
              >
                <a-input   v-decorator="[
              'name',
              {rules: [{ required: true, message: '请输入名称' }]}
            ]"
                         placeholder="请输入名称"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="是否显示"
                      hasFeedback
              >
                <r-switch  :formData="formData" field="status" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="描述"
                      hasFeedback
              >
                <a-textarea    v-decorator="[
              'desc',
              {rules: [ ]}
            ]"
                               placeholder="请输入描述"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
            </a-col>
          </a-row>


        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>



  </a-card>
</template>

<script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import RSwitch from '@/components/RSwitch/'
  import areaOptions from '@/utils/area'
  import moment from 'moment'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

  import { getGroupList ,getGroupDetail,editGroup,addGroup,groupDelete } from '@/api/huiyi'
  export default {
    name: 'HuiyiSaijiList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      RSwitch,
      EditableCell,
    },
    data () {
      return {
                areaOptions,
                visible: false,
                saveLoading:false,
                formData:{
                  id:0,
                  desc:'',
                  status:1
                },
                saijiOptions:[],
                labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
                  xs: { span: 24 },
                  sm: { span: 8 },
                },
                wrapperCol: {
                  xs: { span: 24 },
                  sm: { span: 12 },
                },
                form: this.$form.createForm(this),
                mdl: {},

                // 高级搜索 展开/关闭
                advanced: false,
                // 查询参数
                queryParam: {
                  keywords:'',
                },
                // 表头
                columns: [
                  {
                    title: '#',
                    dataIndex: 'id',
                    width: '50px'
                  },
                  {
                    title: '名称',
                    dataIndex: 'name',
                    scopedSlots: { customRender: 'name' },
                  },
                  {
                    title: '状态',
                    dataIndex: 'status',
                    scopedSlots: { customRender: 'status' },
                  },
                  {
                    title: '操作',
                    dataIndex: 'action',
                    fixed: 'right',
                    width: 200,
                    scopedSlots: { customRender: 'action' },
                  }
                ],
                // 加载数据方法 必须为 Promise 对象
                loadData: parameter => {
                console.log('loadData');
      console.log(this.queryParam);
      let that= this;


      this.queryParam = Object.assign(this.queryParam,parameter);
      return getGroupList(this.queryParam)
                      .then(res => {
                console.log('res');
      return res.data
    })
    },

      selectedRowKeys: [],
              selectedRows: [],
              cashFormData:{
        ids:[],
                to_type:'',
                price:0,
                note:'',
                count:0,
      }
    }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
    },
    methods: {
      moment,
      addHandle(){
        this.formData = {
          id:0,
          desc:'',
          status:1,
        },
          this.form.resetFields();
        this.visible = true
      },
      handleCancel(){
        this.visible = false
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      handleEdit(record){
        let self = this
        this.visible = true
        getGroupDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
          self.form.setFieldsValue({ ...res.data })
          self.formData.id = record.id;
          console.log('handleEdit')
          self.formData = { ...res.data };
        },200)
      })
        // console.log(this.mdl)
      },
      // 查
      onSearch() {
        let self = this;
        self.$refs.table.refresh(false)
      },

      // 增改 处理
      handleOk(e) {
        let self = this;
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;

            if(self.formData.id>0){
              editGroup({
                id:self.formData.id,
                name:values.name,
                desc:values.desc,
                status:self.formData.status,
              }).then(res => {
                self.$message.success('修改成功')
                self.$refs.table.refresh()
                self.visible = false;
                self.saveLoading = false;
              }).catch(err =>{
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }else{
              addGroup({
                name:values.name,
                desc:values.desc,
                status:self.formData.status,
              }).then(res => {
                self.$message.success('保存成功')
                self.$refs.table.refresh(false)
                self.visible = false;
                self.saveLoading = false;
              }).catch(err =>{
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }
          }
        })
      },


      onDelete(record){
        let self = this;
        groupDelete({ id: record.id }).then(res =>{
          self.$refs.table.refresh()
        })
      },
      download(){
        getDownloadUrl(this.queryParam).then(res =>{
          console.log(res);
          window.open(res.data);
        })
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },

    },
    filters:{
    },
    watch: {
    }
  }
</script>
